import { render } from "./card_monitor.vue?vue&type=template&id=c6f767de&scoped=true"
import script from "./card_monitor.vue?vue&type=script&lang=js"
export * from "./card_monitor.vue?vue&type=script&lang=js"

import "./card_monitor.vue?vue&type=style&index=0&id=c6f767de&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f767de"]])

export default __exports__